import { ElementType } from 'react'

import classNames from 'classnames'

import './BreadcrumbItem.scss'

export interface BreadcrumbItemProps {
  children: React.ReactNode
  active?: boolean
  onClick?: () => void
  component?: ElementType
  componentProps?: Record<string, unknown>
  className?: string
}

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  children,
  active,
  onClick,
  component,
  componentProps,
  className,
}) => {
  const isClickable = !active && (!!onClick || !!component)

  const componentClassName =
    componentProps &&
    typeof componentProps === 'object' &&
    'className' in componentProps
      ? (componentProps.className as string | undefined)
      : undefined

  const commonProps = {
    className: classNames(
      'a-breadcrumb-item',
      {
        'a-breadcrumb-item-active': active,
        'a-breadcrumb-item-clickable': isClickable,
      },
      componentClassName,
      className,
    ),
    'aria-current': active ? ('page' as const) : undefined,
  }

  if (component) {
    const Component = component
    return (
      <Component {...(componentProps ?? {})} {...commonProps}>
        {children}
      </Component>
    )
  }

  if (onClick && !active) {
    return (
      <button type="button" onClick={onClick} {...commonProps}>
        {children}
      </button>
    )
  }

  return <span {...commonProps}>{children}</span>
}
